import ForgotPasswordResult from "./ForgotPasswordResult";

export default ForgotPasswordResult;
